module.exports = __webpack_public_path__ + "static/media/grid-6.3a790adb.svg";